/**
 * Converts Params object (which can have string or array values) to a Record<string, string>.
 * Array values are joined with commas.
 */
export function convertParams(params) {
  return Object.entries(params).reduce((result, [key, value]) => {
    result[key] = Array.isArray(value) ? value.join(',') : value;
    return result;
  }, {});
}